<template>
    <div class="container">

        <Fontnavbar title="发货" />

        <van-form @submit="onSubmit">

            <van-field
                v-model="params.logistic_name"
                name="公司名称"
                label="公司名称"
                placeholder="公司名称"
            />
<!--            <van-field-->
<!--                v-model="params.logistic_code"-->
<!--                name="公司编号"-->
<!--                label="公司编号"-->
<!--                placeholder="公司编号"-->
<!--            />-->
            <van-field
                v-model="params.logistic_no"
                name="物流单号"
                label="物流单号"
                placeholder="物流单号"
            />

            <div style="margin: 16px;">
                <van-button round block type="info" native-type="submit">确认</van-button>
            </div>
        </van-form>

    </div>
</template>

<script>
    import { add_logistics } from '@/api.js'
    import { post } from '@/request.js'
    import {
        Button, Card,
        Cell,
        CellGroup, Checkbox, CheckboxGroup,
        Col,
        Dialog, Divider, GoodsAction, GoodsActionButton, GoodsActionIcon,
        Icon,
        Image,
        Loading, Radio, RadioGroup,
        Row,
        Stepper,
        Swipe,
        SwipeItem,
        Tag,
        Form,
        Uploader,
        Toast,
        Field
    } from "vant";
    import Fontnavbar from "../../components/Navbar";
    export default {
        name: "modify",
        components: {
            [Loading.name]: Loading,
            [Image.name]: Image,
            [Tag.name]: Tag,
            [Col.name]: Col,
            [Icon.name]: Icon,
            [Button.name]: Button,
            [Row.name]: Row,
            [Cell.name]: Cell,
            [CellGroup.name]: CellGroup,
            [Swipe.name]: Swipe,
            [Stepper.name]: Stepper,
            [SwipeItem.name]: SwipeItem,
            [GoodsAction.name]: GoodsAction,
            [GoodsActionIcon.name]: GoodsActionIcon,
            [GoodsActionButton.name]: GoodsActionButton,
            [Checkbox.name]: Checkbox,
            [CheckboxGroup.name]: CheckboxGroup,
            [RadioGroup.name]: RadioGroup,
            [Radio.name]: Radio,
            [Card.name]: Card,
            [Divider.name]: Divider,
            [Form.name]: Form,
            [Field.name]: Field,
            [Uploader.name]: Uploader,
            [Toast.name]: Toast,
            Fontnavbar,
        },
        data(){
            return {
                imgDomain: process.env.VUE_APP_IMG_URL,
                params:{
                    id:0, //售后id
                    logistic_name:'',//物流公司名称
                    logistic_code:'',//物流公司代号
                    logistic_no:'',//物流编号
                    logistic_info:'',//物流信息
                },//提交参数
            }
        },
        mounted() {
            this.params.id = this.$route.query.id
        },
        methods: {

            // 提交
            onSubmit(){
                var row = this.getRowData();
                if (row){
                    post(add_logistics, row).then((res) => {
                        if (res.code == 200) {
                            Dialog({ message: res.msg }).then(() => {
                                this.$router.replace({ path: '/service/servicelist' })
                            })
                        } else if (res.code == 201) {
                            Dialog({ message: '您当前未登录' })
                            setTimeout(() => {
                                this.$router.replace({ path: '/user/login' })
                            }, 1000)
                        } else {
                            Dialog({ message: res.msg }).then(() => {
                                this.$router.replace({ path: '/user/index' })
                            })
                        }
                    })
                }
            },
            // 获取提交的数据
            getRowData(){
                if (this.params.logistic_name.length < 1){
                    Toast('请填写物流公司名称');
                    return false;
                }

                if (this.params.logistic_no.length < 1){
                    Toast('请填写物流编号');
                    return false;
                }
                return this.params;
            }
        }
    }
</script>

<style scoped>

</style>